"use client"

import { ShieldCheckIcon } from "@phosphor-icons/react"
import { Cross2Icon, ExternalLinkIcon } from "@radix-ui/react-icons"
import { Popover, Switch } from "@radix-ui/themes"
import { FeatureFlagsContext } from "@src/providers/FeatureFlagsProvider"
import Themes from "@src/types/themes"
import { useTheme } from "next-themes"
import { useContext, useState } from "react"
import { cn } from "@src/utils/cn"
import buttonStyles from "@src/components/Wallet/VeaxButton.module.css"
import styles from "./Settings.module.css"

const Settings = () => {
  const { whitelabelTemplate } = useContext(FeatureFlagsContext)
  const [isOpen, setIsOpen] = useState(false)
  const elementCircleStyle = "bg-white w-[3px] h-[3px] rounded-full"

  return (
    <div>
      <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger>
          <button
            type={"button"}
            className={cn(buttonStyles.veaxButton, buttonStyles.secondary, "!px-[14.5px] !py-[14.5px]")}
          >
            <span className="flex items-center justify-center gap-[2px]">
              <span className={elementCircleStyle} />
              <span className={elementCircleStyle} />
              <span className={elementCircleStyle} />
            </span>
          </button>
        </Popover.Trigger>
        <Popover.Content className="min-w-[300px] w-[300px] mt-1 bg-veax-greyscale-500 border-4 border-veax-greyscale-400 p-0 rounded-none">
          <div className="flex flex-col">
            <div className={styles.menuHeader}>
              <span className={styles.menuHeaderTitle}>// MENU</span>
              <Cross2Icon
                className={styles.menuHeaderClose}
                onClick={() => setIsOpen(false)}
              />
            </div>

            {/* <div className={styles.darkModeToggle}>
              <span>DARK MODE</span>
              <DarkMode />
            </div> */}

            <div className={styles.menuItem}>
              <a
                href="https://docs.near-intents.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>DOCS</span>
                <ExternalLinkIcon width={16} height={16} className={styles.menuItemIcon} />
              </a>
            </div>

            <div className={styles.menuItem}>
              <a
                href="https://t.me/near_intents"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>HELP CENTER</span>
                <ExternalLinkIcon width={16} height={16} className={styles.menuItemIcon} />
              </a>
            </div>

            {/* <div className={styles.menuItem}>
              <a
                href="mailto:defuse@defuse.org"
              >
                <span>REQUEST FEATURE</span>
                <ExternalLinkIcon width={16} height={16} className={styles.menuItemIcon} />
              </a>
            </div> */}

            <div className={styles.menuItem}>
              <a href="/privacy-policy">
                <span>PRIVACY POLICY</span>
              </a>
            </div>

            <div className={styles.menuItem}>
              <a href="/terms-of-service">
                <span>TERMS OF SERVICE</span>
              </a>
            </div>

            {/* {whitelabelTemplate === "near-intents" && (
              <div className={styles.menuItem}>
                <a
                  href="/jobs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>JOBS</span>
                  <ExternalLinkIcon width={16} height={16} className={styles.menuItemIcon} />
                </a>
              </div>
            )} */}

            {/* <div className={styles.menuItem}>
              <a
                href="https://hackenproof.com/programs/near-intents"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center gap-2">
                  <ShieldCheckIcon
                    className="w-4 h-4"
                    aria-hidden="true"
                  />
                  BUG BOUNTY
                </span>
                <ExternalLinkIcon width={16} height={16} className={styles.menuItemIcon} />
              </a>
            </div> */}
          </div>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}

const DarkMode = () => {
  const { setTheme, resolvedTheme } = useTheme()

  // This accounts for system preference when theme is set to "system"
  const isDarkMode = resolvedTheme === Themes.DARK

  return (
    <Switch
      size="1"
      onCheckedChange={(checked: boolean) => {
        setTheme(checked ? Themes.DARK : Themes.LIGHT)
      }}
      checked={isDarkMode}
    />
  )
}

export default Settings
